import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Construction from './pages/Construction';
import registerServiceWorker from './config/registerServiceWorker';

ReactDOM.render(<Construction />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js